<div class="loading-indicator">
  <mat-progress-spinner mode="indeterminate"  *ngIf="isLoading" bdColor="rgba(51,51,51,0.8)" diameter='25' strokeWidth='3'></mat-progress-spinner>
</div>
  <h2 mat-dialog-title>Meeting Templates</h2>
 
  <button mat-icon-button class="template_btn" mat-dialog-close aria-label="Example icon-button with heart icon">
  <mat-icon  class="close-icon" mat-dialog-close>
    close
</mat-icon>
</button>
<mat-divider class="mat-divider"></mat-divider>
<mat-dialog-content class="mat-typography temp_container" [ngStyle]="{'overflow-x':'hidden'}">
  <div contentContainer class="row">
    <div class="col-lg-3 template_left" [ngStyle]="{'position':'fixed', 'width':'17rem', 'padding':'0px'}">
      <h3 class="text-align-center" [ngStyle]="{'padding':'0px', 'margin':'5px 12px', 'text-align':'start', 'font-size':'1.2rem', 'font-weight':'500'}">Categories</h3>
      <mat-divider></mat-divider>
    <div class="" [ngStyle]="{'height':'calc(100vh - 290px)', 'overflow':'auto'}">
      <mat-selection-list #template [multiple]="false">
        <mat-list-option [selected] (click) = "updateSelection(0)" >All Templates</mat-list-option>
        <mat-list-option *ngFor="let template of categoryType" (click) = "updateSelection(template.codeId)" [value]="template.codeId">
          {{template.description}}
        </mat-list-option>
      </mat-selection-list> 
    </div>
  </div>
  <!-- <div class="col-lg-9" [ngStyle]="{'margin-left':'18rem', 'height':'calc(100vh - 258px)', 'overflow':'auto'}">

  </div> -->
  <div class="col-lg-9" [ngStyle]="{'margin-left':'18rem', 'height':'calc(100vh - 258px)', 'overflow':'auto'}">
   
    <div class="text-align-start">
      <mat-form-field floatLabel="auto" class="tempBtn">
        <input matInput class="body-font-size" placeholder="Search" [(ngModel)]="searchText" (input) = "searchTemplateText($event)" (keyup.enter)="searchTemplateName(this.searchText)">
        <mat-icon matSuffix id = "search-icon" (click)="searchTemplateName(this.searchText)">search</mat-icon>
      </mat-form-field>
    </div> 
    <div class="tempaltesList" [hidden]="isLoading">
      <div class="templatelistview">
        <div class="templeCount "  *ngFor = "let seltemplate of templateNames">
          <img class = "img-containerone"  src = "assets/Dummy_1.jpg" alt = "template"/>
          
       <!-- <div class="d-flex showvalue">
        <p class="previewView"  (click) = "previewTemplate(seltemplate)">Preview</p> 
        <p class="useTemplateview" >Use Template</p>
       </div> -->
          <!-- <p class="tempName" (click) = "startMeeting()">{{template.name}}</p> -->
         <div class="width-80">
          <p class="tempName" (click) = "meetingDetails(seltemplate)">{{seltemplate}}</p>
         </div>
        </div> 
        <div *ngIf="templateNames?.length === 0">No records found</div>
        <!-- <div class="templeCount">
          <img class = "img-containerone" src = "assets/basictemplateone.jpg" alt = "template"/>
          <p class="tempName">Blank Template 2</p>
        </div>
        <div class="templeCount">
          <img class = "img-containerone" src = "assets/basictemplate.jpg" alt = "template"/>
          <p class="tempName">Blank Template 1</p>
        </div> 
        <div class="templeCount">
          <img class = "img-containerone" src = "assets/basictemplateone.jpg" alt = "template"/>
          <p class="tempName">Blank Template 2</p>
        </div>
        <div class="templeCount">
          <img class = "img-containerone" src = "assets/basictemplate.jpg" alt = "template"/>
          <p class="tempName">Blank Template 1</p>
        </div> 
        <div class="templeCount">
          <img class = "img-containerone" src = "assets/basictemplateone.jpg" alt = "template"/>
          <p class="tempName">Blank Template 2</p>
        </div>
        <div class="templeCount">
          <img class = "img-containerone" src = "assets/basictemplate.jpg" alt = "template"/>
          <p class="tempName">Blank Template 1</p>
        </div>  
        <div class="templeCount">
          <img class = "img-containerone" src = "assets/basictemplateone.jpg" alt = "template"/>
          <p class="tempName">Blank Template 2</p>
        </div> -->
        <!-- <div class="templeCount">
          <img class = "img-container" src = "assets/Template.jpg" alt = "template"/>
          <p class="tempName">Blank Template</p>
        </div>      -->
       </div>
    </div> 
    <!-- <mat-dialog-actions align="end">
      <div class="col-lg-4 col-sm-12 text-align-end">
        <button mat-raised-button actions class="button-container mar-l-8 primary">
          SCHEDULE
        </button>
        <button mat-raised-button type = "reset" actions class="button-container mar-l-8 primary" #tooltip="matTooltip"  matTooltip="close dialog">
        CANCEL
        </button>
      </div> 
    </mat-dialog-actions> -->
  </div>
  </div>
  
</mat-dialog-content>
